import { useState } from 'react'
import React from 'react'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Chip from '@mui/material/Chip'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import { PATHWAY } from '@/modules/httpService'
import {
  Snackbar
} from '@mui/material'
import { useTranslations } from 'next-intl'

// import DialogActions from '@mui/material/DialogActions'
// import Button from '@mui/material/Button'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

interface ISubmitReportModalProps {
  isLoggedIn: boolean
  reportModalId: string | null
  // eslint-disable-next-line no-unused-vars
  setReportModalId: (id: string | null) => void
}

function SubmitReportModal ({ isLoggedIn, reportModalId, setReportModalId }: ISubmitReportModalProps) {
  const t = useTranslations('SubmitReportModal')
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [message, toggleMessage] = useState(false)

  async function submitReport (id: string, selected: string) {
    setIsSubmitting(true)

    await PATHWAY.post(`/posts/${id}/reports`, {
      selected: selected
    })

    toggleMessage(true)
    setIsSubmitting(false)
    setReportModalId(null)
  }

  return (
    <>
      <Dialog
        open={reportModalId !== null}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setReportModalId(null)}
        aria-describedby='alert-dialog-report'
      >
        {reportModalId !== null &&
          <>
            <DialogTitle>{t('submit-report')}</DialogTitle>
            <IconButton
              aria-label={t('close-menu')}
              onClick={() => setReportModalId(null)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500]
              }}
            >
              <CloseIcon />
            </IconButton>
            {!isLoggedIn &&
              <DialogContent>
                <DialogContentText id='alert-dialog-report' style={{ minWidth: '300px', minHeight: '50px', textAlign: 'center' }}>
                  {t('warning-message')}
                </DialogContentText>
              </DialogContent>
            }
            {isLoggedIn && !isSubmitting &&
              <DialogContent>
                <DialogContentText id='alert-dialog-report'>
                  <div style={{ marginBottom: '1rem' }}>
                    {t('help-us-understand')}
                  </div>
                  <div>
                    {[
                      {
                        label: t('spam'),
                        key: 'spam'
                      },
                      {
                        label: t('selling-products-or-services'),
                        key: 'selling-products-or-services'
                      },
                      {
                        label: t('harassment'),
                        key: 'harassment'
                      },
                      {
                        label: t('hate-speech'),
                        key: 'hate-speech'
                      },
                      {
                        label: t('threatening-violence'),
                        key: 'threatening-violence'
                      },
                      {
                        label: t('sharing-personal-information'),
                        key: 'sharing-personal-information'
                      },
                      {
                        label: t('impersonation'),
                        key: 'impersonation'
                      },
                      {
                        label: t('copyright-violation'),
                        key: 'copyright-violation'
                      },
                      {
                        label: t('trademark-violation'),
                        key: 'trademark-violation'
                      },
                      {
                        label: t('political-propaganda'),
                        key: 'political-propaganda'
                      }
                    ].map((reason, i) => {
                      return (
                        <Chip
                          key={i}
                          style={{ marginRight: 10, marginBottom: 16 }}
                          label={reason.label}
                          variant='outlined'
                          onClick={async () => {
                            await submitReport(reportModalId as string, reason.key)
                          }}
                        />
                      )
                    })}
                  </div>
                </DialogContentText>
              </DialogContent>
            }
            {isLoggedIn && isSubmitting &&
              <DialogContent>
                <DialogContentText id='alert-dialog-report' style={{ minWidth: '400px', minHeight: '100px' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    <CircularProgress />
                  </Box>
                </DialogContentText>
              </DialogContent>
            }
          </>
        }
      </Dialog>
      <Snackbar
        open={message}
        autoHideDuration={6000}
        onClose={() => toggleMessage(false)}
        message={t('thank-you')}
      />
    </>
  )
}

export default SubmitReportModal
